import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-099bfe41"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-viewer__mask" }, null, -1))
const _hoisted_2 = { class: "image-viewer__btn image-viewer__actions" }
const _hoisted_3 = { class: "image-viewer__actions__inner" }
const _hoisted_4 = { class: "image-viewer__canvas" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close_outlined = _resolveComponent("close-outlined")!
  const _component_left_outlined = _resolveComponent("left-outlined")!
  const _component_right_outlined = _resolveComponent("right-outlined")!
  const _component_zoom_out_outlined = _resolveComponent("zoom-out-outlined")!
  const _component_zoom_in_outlined = _resolveComponent("zoom-in-outlined")!
  const _component_undo_outlined = _resolveComponent("undo-outlined")!
  const _component_redo_outlined = _resolveComponent("redo-outlined")!

  return (_openBlock(), _createBlock(_Transition, { name: "viewer-fade" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "image-viewer__wrapper",
        tabindex: "-1",
        class: "image-viewer__wrapper",
        style: _normalizeStyle({ 'z-index': _ctx.zIndex })
      }, [
        _hoisted_1,
        _createElementVNode("span", {
          class: "image-viewer__btn image-viewer__close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
        }, [
          _createVNode(_component_close_outlined)
        ]),
        (!_ctx.isSingle)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", {
                class: "image-viewer__btn image-viewer__prev",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
              }, [
                _createVNode(_component_left_outlined)
              ]),
              _createElementVNode("span", {
                class: "image-viewer__btn image-viewer__next",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
              }, [
                _createVNode(_component_right_outlined)
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_zoom_out_outlined, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleActions('zoomOut')))
            }),
            _createVNode(_component_zoom_in_outlined, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleActions('zoomIn')))
            }),
            _createVNode(_component_undo_outlined, {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleActions('anticlocelise')))
            }),
            _createVNode(_component_redo_outlined, {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleActions('clocelise')))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            ref: "img",
            class: "image-viewer__img",
            src: _ctx.currentImg,
            style: _normalizeStyle(_ctx.imgStyle),
            onLoad: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleImgLoad && _ctx.handleImgLoad(...args)))
          }, null, 44, _hoisted_5)
        ])
      ], 4)
    ]),
    _: 1
  }))
}